import React from "react"
import styled from "styled-components"
import { breakpoint } from "../utils/breakpoint"

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 14px;
  height: 14px;

  ${breakpoint.sm} {
    width: 12px;
    height: 12px;
  }

  ${breakpoint.lg} {
    width: 9px;
    height: 9px;
  }
`
const StyledDiv = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #c4c4c4;

  ${breakpoint.sm} {
    width: 8px;
    height: 8px;
  }

  ${breakpoint.lg} {
    width: 6px;
    height: 6px;
  }
`
const GreyCircle = props => {
  return (
    <StyledWrapper>
      <StyledDiv
        style={{
          ...props.style,
        }}
      />
    </StyledWrapper>
  )
}

export default GreyCircle
